<template>
  <div>
    <flow-steps :steps="importSteps"></flow-steps>
  </div>
</template>

<script>
import FlowSteps from '../shared/FlowSteps';

export default {
  name: 'import-steps',
  components: {FlowSteps},
  data() {
    return {
      steps: [
        {name: 'Choose Method', href: '/import/select-method'},
        {name: 'Select Groups', href: '/import/select-groups'},
        {name: 'Confirm Details', href: '/import/confirm'},
        {name: 'Progress', href: '/import/progress'},
        {name: 'Complete', href: '/import/complete'},
      ],
    };
  },
  computed: {
    currentStep() {
      return this.steps.findIndex(item => this.activePath.includes(item.href));
    },
    importSteps() {
      return this.steps.map((step, index) => {
        step.status =
          index === this.currentStep && index != this.steps.length - 1
            ? 'active'
            : index > this.currentStep
            ? 'incomplete'
            : 'completed';
        return {...step};
      });
    },
    activePath() {
      return window.location.pathname;
    },
  },
};
</script>
